import React from 'react';
import bem from 'utils/bem';
import {PulsingDot} from "components/PulsingDot";
import Text from "components/Text";
import './index.sass';

const { block, el } = bem('text-with-dot');
export const TextWithPulsingDot = ({idle, hasBackground = false, children}) => {
    return <div className={block()} style={ hasBackground ? {background: 'rgba(55,116,91,0.1)', borderRadius: '4px', paddingLeft: '8px', paddingRight: '8px'} : {}}>
        { !idle && <PulsingDot idle={idle} /> }
        <Text>{children}</Text>
    </div>
}
